<template>
  <div class="tooltip-container">
    <span v-if="isTooltipVisible" class="tooltip-text">
      <i class="custom-margin fas fa-phone fa-fw cursor-pointer" title="Ligar" @click="ligar"></i>
      <i class="custom-margin fas fa-phone-slash fa-fw cursor-pointer" title="Desligar" @click="desligar"></i>
      <i class="custom-margin fas fa-hand-rock fa-fw cursor-pointer" title="Puxar" @click="puxar"></i>
      <i class="custom-margin fas fa-headphones fa-fw cursor-pointer" title="Escutar" @click="escutar"></i>
      <i class="custom-margin fas fa-phone-volume fa-fw cursor-pointer" title="Sussurrar" @click="sussurar"></i>
    </span>
    <i class="fa-solid fa-bars cursor-pointer" @click="toggleTooltip"></i>
  </div>
</template>

<script>
import Vue from 'vue';
const tgTip = new Vue();

export default {
  props: ['nome', 'channel','extension', 'status', 'conSocket', 'departments', 'id'],
  name: "ToolTip",
  data() {
    return {
      ramal: user.getExtension(),
      call: {
        time: '00:00:00',
        num: '',
        oldNum: '',
        type: '',
      },
      isTooltipVisible: false,
    };
  },
  methods: {
    toggleTooltip() {
      if (!this.isTooltipVisible) {
        tgTip.$emit('closeAllTooltips');
      }
      this.isTooltipVisible = !this.isTooltipVisible;
      this.$nextTick(() => {
        if (this.isTooltipVisible) {
          this.adjustTooltipPosition();
        }
      });
    },
    adjustTooltipPosition() {
      const tooltip = this.$el.querySelector('.tooltip-text');
      if (tooltip) {
        const rect = tooltip.getBoundingClientRect();
        tooltip.style.bottom = '150%';
        tooltip.style.left = 'calc(50% - 10px)';
        tooltip.style.transform = 'translateX(-50%)';

        if (rect.right > window.innerWidth) {
          tooltip.style.left = 'auto';
          tooltip.style.right = '10px';
          tooltip.style.transform = 'none';
        }

        if (rect.left < 0) {
          tooltip.style.left = '10px';
          tooltip.style.transform = 'none';
        }
      }
    },
    ligar() {
      this.conSocket.emit('Originate', {
        calltype: 'outgoing',
        extension: this.ramal,
        phone: this.extension
      });
      this.call.type = 'sainte';
    },
    desligar() {
      this.conSocket.emit('hangup', {
        channel: this.channel
      });
      console.log(this.channel)
      this.call.type = '';
    },
    puxar() {
      const data = {
        channel: this.ramal,
        exten: `701${this.extension}`
      };
      this.call.type = '';

      this.conSocket.emit('pickupCall', data);
    },
    sussurar() {
      const data = {
        channel: this.ramal,
        exten: `702${this.extension}`
      };
      this.call.type = '';

      this.conSocket.emit('suportOperator', data);
    },
    escutar(){
      const data = {
        channel: this.ramal,
        exten: `700${this.extension}`
      };
      this.call.type = '';

      this.conSocket.emit('listenOperator', data);
    },
    closeTooltip() {
      this.isTooltipVisible = false;
    },

  },
  mounted() {
    tgTip.$on('closeAllTooltips', this.closeTooltip);

  },
  beforeDestroy() {
    tgTip.$off('closeAllTooltips', this.closeTooltip);
  },
};
</script>

<style scoped>
.custom-margin {
  margin-left: 15px;
}

.tooltip-container {
  position: relative;
  display: inline-block;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.tooltip-text {
  visibility: visible;
  width: 200px;
  background-color: white;
  color: black;
  font-size: 0.9em;
  text-align: left;
  border-radius: 5px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 2em black;
  transition: bottom 0.3s ease;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 12px;
  border-color: white transparent transparent transparent;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%) rotate(90deg);
}
</style>
